import gql from "graphql-tag";

export default gql`
	mutation purchase($purchaseInput: PurchaseInput!) {
		purchase(purchaseInput: $purchaseInput) {
			orderNumber
			paymentID
			order {
				subscriptionID
				subscription {
					isFromTrial
					plan {
						planCode
					}
				}
			}
		}
	}
`;

export const readPaymentResult = ({ data }) =>
	data && {
		...data.purchase,
	};
